/** Shared client auth cleanup (avoids circular imports between api ↔ store). */

const AUTH_STORAGE_KEYS = [
  'access_token',
  'refresh_token',
  'auth_user',
  'field-force-auth',
] as const;

type AuthClearListener = () => void;
const listeners = new Set<AuthClearListener>();

export function onAuthCleared(listener: AuthClearListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function clearAuthStorage(): void {
  for (const key of AUTH_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}

/** Clear persisted auth tokens/state and notify in-memory listeners (Zustand). */
export function clearClientAuth(): void {
  clearAuthStorage();
  listeners.forEach((listener) => listener());
}
